/**
 * Verrouillage progression (client) : les pages affichent FeatureGateLockedPanel
 * au lieu de rediriger — le joueur voit la progression de déblocage.
 */
export default defineNuxtRouteMiddleware(() => {
  /* Intentionnellement vide : géré par FeatureGateLockedPanel sur chaque page. */
})
